var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-card ics-flex_center"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"user-card-wrap"},[_c('div',{staticClass:"user-card-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"user-card-content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }